import React, { Component } from 'react';
import { Button, InputGroup, EditableText, Menu, Icon, NumericInput } from "@blueprintjs/core";
import Files from 'react-files'
import { connect } from 'react-redux';
import { actions } from '../../config/reduxIndex';

const MAX_FILES = 10;

class FileDropzoneContainer extends Component {
	state = {
		arrOfImages: [],
		arrOfPdf: [],
		currentFile: 0
	}

	render() {
		return (
			<div>
				{this.files()}
			</div>
		);
	}

	files() {
		return (
			<div className="FileDZImages">

				<Files
					className='files-dropzone'
					onChange={this.onFilesChange}
					onError={this.onFilesError}
					accepts={['application/pdf', 'image/png', 'image/jpeg', 'image/jpg']}
					multiple
					maxFiles={MAX_FILES}
					maxFileSize={10000000}
					minFileSize={0}
					clickable
				>
					<Icon icon="upload" /> Drop files here or click to upload

				</Files>

				{this.state.arrOfImages.length > 0 ? this.img() : null}

				{this.state.arrOfPdf.length > 0 ? this.pdf() : null}

			</div>
		);
	}

	img = () => {
		return (
			<div className="PdfPrv" >
				{this.state.arrOfImages.map((img, index) => {
					return (
						<div className="imagePrvBorder" key={"image-preview-" + index}>
							<div className="imagePrvBorderClose" >
								<Button icon='cross' type="button" className="pt-button pt-intent-danger" onClick={this.onImageRemove} />
							</div>
							<div className="FileDZPreview" onClick={() => this.onImageClick(img)}>
								<img src={img} />
							</div>
						</div>
					)
				})}
			</div>
		)
	}

	pdf = () => {
		return (
			<div className="PdfPrv" >
				{this.state.arrOfPdf.map((pdf, index) => {
					return (
						<div className="PdfPrvItem" key={"pdf-preview-" + index}>
							<div className="PdfPrvEmbed" >
								<embed src={pdf} type="application/pdf" />
							</div>

							<a href={pdf} download >
								Download
						</a>
						</div>
					)
				})}
			</div>
		)
	}

	onImageHover = () => {
		console.log("Image hover");
	}

	onImageClick = () => {
		console.log("Image click");
	}

	onImageRemove = () => {
		console.log("Image remove");
	}

	onFilesChange = event => {
		const { currentFile, arrOfImages, arrOfPdf } = this.state;
		if (arrOfImages.length + arrOfPdf.length < MAX_FILES) {
			if (event[currentFile].extension === 'pdf') {
				getBase64(event[this.state.currentFile]).then(
					data => this.setState(
						{
							arrOfPdf: [...this.state.arrOfPdf, data],
							currentFile: this.state.currentFile + 1
						}
					)
				);
			} else if (event[currentFile].extension === 'png' || event[currentFile].extension === 'jpg' || event[currentFile].extension === 'jpeg') {
				this.setState(
					{
						arrOfImages: [...this.state.arrOfImages, event[this.state.currentFile].preview.url],
						currentFile: this.state.currentFile + 1
					}
				)
			} 
		} 

		function getBase64(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.readAsDataURL(file);
				reader.onload = () => resolve(reader.result);
				reader.onerror = error => reject(error);
			});
		}

	}

	onFilesError = event => {
		console.log(event);
		// TODO alert user
	}

}

function mapStateToProps(state) {
	return {

	}
}

const mapDispatchToProps = dispatch => {
	return {
		cancelEdit: () => {
			dispatch(actions.globalState.closeOverlay());
		},
		openImageEditOverlay: (props) => {
			dispatch(actions.globalState.openOverlay('bpImageEdit'));
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(FileDropzoneContainer);



// WEBPACK FOOTER //
// ./src/containers/projectmanager/FileDropzoneContainer.js